<template lang="html">
  <div class="">
    <v-slide-y-transition>
      <v-container
        v-if="!_loader"
        grid-list-lg
      >
        <v-layout wrap>
          <v-flex
            xs12
            lg10
            xl8
            mx-auto
          >
            <v-layout wrap>
              <v-flex
                xs12
                md4
                style="min-width:280px "
              >
                <v-layout wrap>
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="healine">
                        Settings
                        <v-spacer />
                      <!-- <v-btn text color="primary" small><v-icon left>launch</v-icon>Preview</v-btn> -->
                      </v-card-title>

                      <v-container
                        grid-list-md
                        fluid
                        px-4
                      >
                        <v-layout wrap>
                          <v-flex
                            xs12
                            mb-2
                          >
                            <div class="subtitle-2">
                              Name
                            </div>
                            <div class="caption grey--text darken-2">
                              Calculator title. Each variant still requires its own name
                            </div>
                          </v-flex>
                          <v-flex xs12>
                            <SiInputText
                              v-model="calculator.name"
                              label="calculator name"
                              single-line
                              hide-details
                              outlined
                              class="pa-0"
                              @change="save"
                            />
                          </v-flex>
                          <v-flex
                            xs12
                            mb-2
                          >
                            <div class="subtitle-2">
                              Category
                            </div>
                            <div class="caption grey--text darken-2">
                              Categories used to group like calculators. Select an existing category or type a new one
                            </div>
                          </v-flex>
                          <v-flex xs12>
                            <v-combobox
                              v-model="calculator.category"
                              :search-input.sync="categorySearch"
                              label="Category"
                              :items="categories"
                              single-line
                              hide-details
                              outlined
                              class="pa-0"
                              @change="save"
                            >
                              <template #no-data>
                                <v-list-item>
                                  <v-list-item-content>
                                    <v-list-item-title>
                                      Press <kbd>enter</kbd> to create {{ categorySearch }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </template>
                            </v-combobox>
                          </v-flex>
                          <v-flex
                            xs12
                            mt-4
                            mb-2
                          >
                            <div class="subtitle-2">
                              Status
                            </div>
                            <div class="caption grey--text darken-2">
                              Control visiblity of calculator
                            </div>
                          </v-flex>
                          <v-flex xs12>
                            <v-btn
                              block
                              :color="calculator._disabled ? 'warning' : 'success'"
                              @click="toggleCalculator(calculator._disabled)"
                            >
                              <v-icon left>
                                {{ calculator._disabled ? 'close' : 'done' }}
                              </v-icon>{{ calculator._disabled ? 'DISABLED' : 'ACTIVE' }}
                            </v-btn>
                          </v-flex>
                          <v-flex
                            xs12
                            mt-4
                            mb-2
                          >
                            <div class="subtitle-2">
                              Report Access
                            </div>
                            <div class="caption grey--text darken-2">
                              Controls how reports are accessed. UNRESTRICTED reports only require a unique link, while RESTRICTED reports can only be accessed via single use links.
                            </div>
                          </v-flex>
                          <v-flex xs12>
                            <SiDeleteButton
                              :title="`${calculator.unrestricted ? 'RESTRICT' : 'UNRESTRICT'} CALCULATOR`"
                              :message="`Are you certain you want to <strong>${calculator.unrestricted ? 'RESTRICT' : 'UNRESTRICT'}</strong> this calculator? This setting controls how reports are be accessed`"
                              :challenge="calculator.unrestricted ? 'restrict' : 'unrestrict'"
                              :delete-button-text="calculator.unrestricted ? 'restrict' : 'unrestrict'"
                              :challenge-text="calculator.unrestricted ? 'To restrict type' : 'To unrestrict type'"
                              :icon="calculator.unrestricted ? 'lock' : 'lock_open'"
                              @delete="setRestrictedState()"
                            >
                              <template #activator="{ on }">
                                <v-btn
                                  block
                                  :color="calculator.unrestricted ? 'warning' : 'error'"
                                  v-on="on"
                                >
                                  <v-icon left>
                                    {{ calculator.unrestricted ? 'lock_open' : 'lock' }}
                                  </v-icon>{{ calculator.unrestricted ? 'unrestricted' : 'restricted' }}
                                </v-btn>
                              </template>
                            </SiDeleteButton>
                          </v-flex>
                          <v-flex
                            xs12
                            mt-4
                            mb-2
                          >
                            <div class="subtitle-2">
                              Image
                            </div>
                            <div class="caption grey--text darken-2">
                              Displayed on calculator's product card
                            </div>
                          </v-flex>
                          <v-layout
                            justify-center
                            ma-0
                            mb-4
                          >
                            <v-flex shrink>
                              <SiImage 
                                :image="calculator.image" 
                                :aspect-ratio="1" 
                                :width="120" 
                                save-path="assets" 
                                border 
                                :register-paths="[calculatorListPath, calculatorDetailsPath]"
                              />
                            </v-flex>
                          </v-layout>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-flex>
                  <v-flex text-center>
                    <v-btn
                      text
                      color="grey"
                      @click="exportCalculator"
                    >
                      <v-icon left>
                        vertical_align_bottom
                      </v-icon> Export Calculator
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex
                xs12
                md8
              >
                <v-layout wrap>
                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="healine">
                        Variants
                      </v-card-title>
                      <v-tabs
                        v-if="showTabs"
                        v-model="tab"
                      >
                        <v-tab
                          v-for="variant in calculatorVariants"
                          :key="variant.id"
                          :href="`#tab_${variant.id}`"
                        >
                          <v-badge
                            color="error"
                            overlap
                            :value="!valid[variant.id]"
                          >
                            <template #badge>
                              <span>!</span>
                            </template>
                            <v-icon>assessment</v-icon>
                          </v-badge>
                          <i
                            style="text-transform: lowercase;"
                            class="ml-3"
                          >{{ variant.id }}</i>
                          <span class="grey--text ml-2">{{ _$(variant.product.price) }}</span>
                        </v-tab>
                        <!-- <v-tab :ripple="false"> -->
                        <v-btn
                          text
                          color="primary"
                          class="ma-2"
                          :disabled="_loader"
                          @click="variableMenu = true"
                        >
                          <v-icon left>
                            assessment
                          </v-icon> New
                        </v-btn>
                      <!-- </v-tab> -->
                      </v-tabs>
                      <v-divider />

                      <v-dialog
                        v-model="variableMenu"
                        max-width="600"
                      >
                        <v-card>
                          <v-card-text>
                            <SiVariableEditor
                              ref="template_var_input"
                              active
                              variable-term="variant id"
                              :existing-variables="calculator.variants"
                              @variable="addVariant"
                              @cancel="variableMenu = false"
                            />
                          </v-card-text>
                        </v-card>
                      </v-dialog>

                      <v-tabs-items v-model="tab">
                        <v-tab-item
                          v-for="(variant, i) in calculatorVariants"
                          :key="variant.id"
                          :value="`tab_${variant.id}`"
                          class="fill-height"
                        >
                          <v-form
                            ref="form"
                            v-model="valid[variant.id]"
                          >
                            <v-container
                              grid-list-md
                              fluid
                              px-4
                            >
                              <v-layout wrap>
                                <v-flex>
                                  <v-layout wrap>
                                    <v-flex
                                      xs12
                                      mt-4
                                      mb-2
                                    >
                                      <div class="subtitle-2">
                                        Status
                                      </div>
                                      <div class="caption grey--text darken-2">
                                        Controls visibility of variant.
                                      </div>
                                    </v-flex>

                                    <v-flex xs12>
                                      <v-btn
                                        :color="variant._disabled ? 'warning' : 'success'"
                                        @click="toggleVariant(variant.id, variant._disabled)"
                                      >
                                        <v-icon left>
                                          {{ variant._disabled ? 'close' : 'done' }}
                                        </v-icon>{{ variant._disabled ? 'DISABLED' : 'ACTIVE' }}
                                      </v-btn>
                                    <!-- <SiInputSwitch v-model="variant._disabled" outlined autofocus hide-details label="Acive" @change="save"/> -->
                                    </v-flex>

                                    <v-flex
                                      xs12
                                      mt-4
                                      mb-2
                                    >
                                      <div class="subtitle-2">
                                        Details
                                      </div>
                                      <div class="caption grey--text darken-2">
                                        Information about calculator that is displayed at the top of the calculator and links to it.
                                      </div>
                                    </v-flex>

                                    <v-flex xs12>
                                      <SiInputText
                                        v-model="variant.name"
                                        outlined
                                        autofocus
                                        hide-detailsx
                                        label="Name"
                                        required
                                        @change="save"
                                      />
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputTextarea
                                        v-model="variant.description"
                                        outlined
                                        rows="2"
                                        auto-grow
                                        hide-detailsx
                                        label="Description"
                                        required
                                        @change="save"
                                      />
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputTextarea
                                        v-model="variant.moreInfo"
                                        outlined
                                        rows="2"
                                        auto-grow
                                        hide-detailsx
                                        label="More Info"
                                        required
                                        @change="save"
                                      />
                                    </v-flex>

                                    <v-flex
                                      xs12
                                      mt-4
                                      mb-2
                                    >
                                      <div class="subtitle-2">
                                        Price
                                      </div>
                                      <div class="caption grey--text darken-2">
                                        Product information about this calculator. Sets the price and text used on the receipt
                                      </div>
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputText
                                        v-model="variant.product.receiptText"
                                        outlined
                                        hide-detailsx
                                        label="Receipt text"
                                        required
                                        @change="save"
                                      />
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      md6
                                    >
                                      <SiInputCurrency
                                        v-model="variant.product.price"
                                        outlined
                                        hide-detailsx
                                        cents
                                        label="Price"
                                        required
                                        :error="variant.price < ''"
                                        @change="save"
                                      />
                                    </v-flex>
                                    <v-flex
                                      xs12
                                      md6
                                    >
                                      <SiInputCurrency
                                        v-model="variant.product.licensePrice"
                                        outlined
                                        cents
                                        label="License Price"
                                        required
                                        :error="variant.licensePrice < ''"
                                        @change="save"
                                      />
                                    </v-flex>

                                    <v-flex
                                      xs12
                                      mt-4
                                      mb-2
                                    >
                                      <div class="subtitle-2">
                                        Emailing
                                      </div>
                                      <div class="caption grey--text darken-2">
                                        Text that will be used in the email sent out with the calculation link.
                                      </div>
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputText
                                        v-model="variant.email.title"
                                        outlined
                                        hide-detailsx
                                        label="Content title"
                                        required
                                        @change="save"
                                      />
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputText
                                        v-model="variant.email.subject"
                                        outlined
                                        hide-detailsx
                                        label="Subject line"
                                        required
                                        @change="save"
                                      />
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputText
                                        v-model="variant.email.previewText"
                                        outlined
                                        hide-detailsx
                                        cents
                                        label="Preview text"
                                        required
                                        :error="variant.price < ''"
                                        @change="save"
                                      />
                                    </v-flex>
                                  </v-layout>
                                </v-flex>

                                <v-flex
                                  xs12
                                  pa-0
                                />

                                <v-flex>
                                  <v-layout wrap>
                                    <v-flex
                                      xs12
                                      mt-4
                                      mb-2
                                    >
                                      <div class="subtitle-2">
                                        Getting started
                                      </div>
                                      <div class="caption grey--text darken-2">
                                        Text to help a client understand what they will need to preform a calculation. If set this text will display at the top of the calculator.
                                      </div>
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiQuill 
                                        v-model="variant.gettingStartedText" 
                                        @blur="save"
                                      />
                                    </v-flex>

                                    <v-flex
                                      xs12
                                      mt-4
                                      mb-2
                                    >
                                      <div class="subtitle-2">
                                        Assistance
                                      </div>
                                      <div class="caption grey--text darken-2">
                                        Sets if a calculator is elidgble for assistance. Text promts a user about what assistance is. Assistance fields are information collected when they submit a request.
                                      </div>
                                    </v-flex>
                                    <v-flex xs12>
                                      <SiInputSwitch
                                        v-model="variant.canHaveAssistance"
                                        outlined
                                        label="Eligible for assistance"
                                        @change="save"
                                      />
                                    </v-flex>

                                    <v-slide-y-transition>
                                      <v-flex
                                        v-if="variant.canHaveAssistance"
                                        xs12
                                        pa-0
                                      >
                                        <v-flex xs12>
                                          <v-select
                                            v-model="variant.assistanceTypes"
                                            :items="assistanceTypes"
                                            chips
                                            label="Assistance Types"
                                            multiple
                                            outlined
                                            @change="() => handleAssistanceTypesChange(variant.id)"
                                          >
                                            <template #item="{ item, attrs }">
                                              <v-list-item-icon>
                                                <v-icon v-text="attrs.inputValue ? 'check_box' : 'check_box_outline_blank'" />
                                              </v-list-item-icon>
                                              <v-list-item-content>
                                                <v-list-item-title v-html="item.text" />
                                                <v-list-item-subtitle v-html="item.subtext" />
                                              </v-list-item-content>
                                            </template>
                                            <!-- <template v-slot:item="{ item }">
                                            <template >
                                              <v-list-item-content>
                                                <v-list-item-title v-html="item.text"></v-list-item-title>
                                                <v-list-item-subtitle v-html="item.subtext"></v-list-item-subtitle>
                                              </v-list-item-content>
                                            </template>
                                          </template> -->
                                          </v-select>
                                        </v-flex>
                                        <v-flex xs12>
                                          <SiQuill
                                            v-model="variant.assistanceText" 
                                            required 
                                            @blur="save"
                                          />
                                        </v-flex>
                                        <v-flex
                                          xs12
                                          mt-3
                                          class="subheading"
                                        >
                                          <div>Assistance Fields</div>
                                          <div class="caption grey--text darken-2">
                                            Fields of information that are requested when a client submits an assistance request
                                          </div>
                                        </v-flex>                                      <v-flex xs12>
                                          <v-divider />
                                        </v-flex>
                                        <SiFieldListEditor
                                          v-model="variant.assistanceFields"
                                          :fields="fields"
                                          :all-picked-fields="variant.assistanceFields"
                                          required
                                          @change="save"
                                        />

                                        <v-flex
                                          xs12
                                          mt-3
                                          class="subheading"
                                        >
                                          <div>Assistance Addons</div>
                                          <div class="caption grey--text darken-2">
                                            Optional addon services that can be selected by the client when requesting an assistance.
                                          </div>
                                        </v-flex>

                                        <v-flex xs12>
                                          <v-divider />
                                        </v-flex>
                                        <v-flex
                                          v-for="addon in variant.addons"
                                          :key="addon.id"
                                          xs12
                                        >
                                          <v-card>
                                            <v-layout
                                              align-center
                                              fill-height
                                              ma-0
                                              pa-3
                                            >
                                              <v-flex
                                                shrink
                                                pa-0
                                                pr-2
                                              >
                                                <div class="subheading font-weight-bold">
                                                  {{ addon.name }} <span class="grey--text">{{ _$(addon.price) }}</span>
                                                </div>
                                                <div class="caption grey--text">
                                                  {{ addon.id }}
                                                </div>
                                              </v-flex>
                                              <v-spacer />
                                              <v-btn
                                                text
                                                color="grey"
                                                @click="openPanel('panels', addon.id)"
                                              >
                                                {{ panels[addon.id] === 0 ? 'Done' : 'Edit' }}
                                              </v-btn>
                                            </v-layout>
                                            <v-expansion-panels
                                              v-model="panels[addon.id]"
                                              class="si-expansion-panel-flat"
                                            >
                                              <v-expansion-panel expand-icon="edit">
                                                <v-expansion-panel-content>
                                                  <v-container
                                                    grid-list-md
                                                    px-0
                                                  >
                                                    <v-layout wrap>
                                                      <v-flex xs12>
                                                        <SiInputText
                                                          v-model="addon.name"
                                                          outlined
                                                          autofocus
                                                          hide-detailsx
                                                          label="Name"
                                                          @change="save"
                                                        />
                                                      </v-flex>
                                                      <v-flex xs12>
                                                        <SiInputText
                                                          v-model="addon.subtext"
                                                          outlined
                                                          autofocus
                                                          hide-detailsx
                                                          label="Sub text"
                                                          hint="Brief descriptive info about the service"
                                                          @change="save"
                                                        />
                                                      </v-flex>
                                                      <v-flex xs12>
                                                        <SiInputText
                                                          v-model="addon.receiptText"
                                                          outlined
                                                          hide-detailsx
                                                          label="Receipt text"
                                                          @change="save"
                                                        />
                                                      </v-flex>

                                                      <v-flex xs6>
                                                        <SiInputCurrency
                                                          v-model="addon.price"
                                                          outlined
                                                          hide-detailsx
                                                          cents
                                                          label="Price"
                                                          :error="addon.price < ''"
                                                          @change="save"
                                                        />
                                                      </v-flex>

                                                      <v-flex xs6>
                                                        <SiInputCurrency
                                                          v-model="addon.licensePrice"
                                                          outlined
                                                          hide-detailsx
                                                          cents
                                                          label="License Price"
                                                          :error="addon.licensePrice < ''"
                                                          @change="save"
                                                        />
                                                      </v-flex>

                                                      <v-flex
                                                        xs12
                                                        text-center
                                                      >
                                                        <SiDeleteButton
                                                          title="Delete addon?"
                                                          :message="`Are you certain you want to delete this add-on <strong>${addon.id}</strong>?`"
                                                          :challenge="addon.id"
                                                          @delete="deleteAddon(variant.id, addon.id)"
                                                        >
                                                          <template #activator="{ on }">
                                                            <v-btn
                                                              text
                                                              color="grey"
                                                              v-on="on"
                                                            >
                                                              Delete
                                                            </v-btn>
                                                          </template>
                                                        </SiDeleteButton>
                                                      </v-flex>
                                                    </v-layout>
                                                  </v-container>
                                                </v-expansion-panel-content>
                                              </v-expansion-panel>
                                            </v-expansion-panels>
                                          </v-card>
                                        </v-flex>
                                        <v-flex pt->
                                          <SiVariableEditor
                                            right
                                            variable-term="addon id"
                                            prefix="addon_"
                                            :existing-variables="variant.addons"
                                            @variable="addAddon(variant.id, $event)"
                                          />
                                        </v-flex>
                                      </v-flex>
                                    </v-slide-y-transition>

                                    <v-flex
                                      v-if="(calculatorVariants || []).length > 1"
                                      xs12
                                    >
                                      <v-divider />
                                    </v-flex>

                                    <v-layout
                                      align-center
                                      ma-0
                                      mb-1
                                    >
                                      <v-dialog
                                        v-model="confirmCopydialog"
                                        max-width="400"
                                      >
                                        <v-card>
                                          <v-card-title class="headline">
                                            Overwrite all data?
                                          </v-card-title>
                                          <v-card-text>Are you sure you want to copy all data from this variant? <br>This will overwrite everything in the current variant.</v-card-text>
                                          <v-card-actions>
                                            <v-spacer />
                                            <v-btn
                                              color="grey"
                                              text
                                              @click="confirmCopydialog = false"
                                            >
                                              Cancel
                                            </v-btn>
                                            <v-btn
                                              color="primary"
                                              text
                                              @click="copyVariant"
                                            >
                                              Yes, Do it
                                            </v-btn>
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>

                                      <v-menu
                                        v-if="calculatorVariants.length > 1"
                                        offset-y
                                      >
                                        <template #activator="{ on, attrs }">
                                          <v-btn
                                            text
                                            color="grey"
                                            v-bind="attrs"
                                            v-on="on"
                                          >
                                            <v-icon left>
                                              filter_none
                                            </v-icon> Copy
                                          </v-btn>
                                        </template>
                                        <v-list>
                                          <v-list-item
                                            v-for="v in calculatorVariants.filter(x => x.id !== variant.id)"
                                            :key="v.id"
                                            @click="copyVariantRequest(v.id, variant.id)"
                                          >
                                            <v-list-item-content>
                                              <v-list-item-title>{{ v.id }}</v-list-item-title>
                                              <v-list-item-subtitle>{{ v.name }}</v-list-item-subtitle>
                                            </v-list-item-content>
                                          </v-list-item>
                                        </v-list>
                                      </v-menu>
                                      <SiDeleteButton
                                        v-if="calculatorVariants.length > 1"
                                        title="Delete Variant?"
                                        :message="`Are you certain you want to delete this calculator variant <strong>${variant.id}</strong>? Deleting this incorrectly will break shit.`"
                                        :challenge="variant.id"
                                        @delete="deleteVariant(variant.id)"
                                      >
                                        <template #activator="{ on }">
                                          <v-btn
                                            text
                                            color="grey"
                                            v-on="on"
                                          >
                                            <v-icon left>
                                              delete
                                            </v-icon>Delete Varaint
                                          </v-btn>
                                        </template>
                                      </SiDeleteButton>
                                      <v-spacer />
                                      <v-flex
                                        v-if="(calculatorVariants || []).length > 1"
                                        shrink
                                      >
                                        <v-layout align-center>
                                          <v-btn
                                            color="primary"
                                            text
                                            icon
                                            :disabled="i === 0"
                                            @click="reIndex(i, i - 1)"
                                          >
                                            <v-icon>arrow_back</v-icon>
                                          </v-btn>
                                          <span class="v-label">Order {{ i + 1 }}</span>
                                          <v-btn
                                            color="primary"
                                            text
                                            icon
                                            :disabled="i === (calculatorVariants || []).length - 1"
                                            @click="reIndex(i, i + 1)"
                                          >
                                            <v-icon>arrow_forward</v-icon>
                                          </v-btn>
                                        </v-layout>
                                      </v-flex>
                                    </v-layout>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-form>
                        </v-tab-item>
                      </v-tabs-items>
                    </v-card>
                  </v-flex>

                  <v-flex xs12>
                    <v-card>
                      <v-card-title class="healine">
                        Disclaimer
                      </v-card-title>
                      <v-container
                        grid-list-md
                        fluid
                        px-4
                      >
                        <SiQuill 
                          v-model="calculator.disclaimer" 
                          @blur="save"
                        />
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </v-slide-y-transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import helpers from '@/mixins/helpers'
import binder from '@/mixins/binder'
import validations from '@/mixins/validations'
import { rtdb } from '@/plugins/firebase'

export default {
  mixins: [ helpers, validations, binder ],
  props: {
    calculatorId: String,
    fields: Object,
    loading: Boolean
  },
  data () {
    return {
      tab: null,
      showTabs: true,
      variableMenu: false,
      calculator: {},
      calculatorVariants: [],
      valid: {},
      confirmCopydialog: false,
      saveTimeout: null,
      saveActive: null,
      saveFunction: null,
      categorySearch: '',
      panels: {},
      variantsToCopy: {},
    }
  },
  computed: {
    ...mapGetters(['_calculators', '_loader', '_assistanceTypes']),
    calculatorDetailsPath () {
      return `calculators/_details/${this.calculatorId}`
    },
    calculatorListPath () {
      return `calculators/_list/${this.calculatorId}`
    },
    pageStyles () {
      return { 'xs12': true, 'sm10': true, 'md8': true, 'xl6': true, 'offset-sm1': false, 'offset-md2': false, 'offset-xl3': false }
    },
    categories () {
      return [...new Set(Object.keys(this._calculators).map(k => this._calculators[k].category).filter(c => c !== undefined))]
    },
    assistanceTypes () {
      return this._sortObject(this._assistanceTypes).map(t => ({ value: t.id, text: `${t.name} (${this._$(t.price)})`, subtext: `${t.id} | ${t.duration}`}))
    }
  },
  watch: {
    variableMenu (v) {
      requestAnimationFrame(() => {
        if (v) this.$refs.template_var_input.focus()
      })
    },
    '$route.params.sub' () {
      this.tab = null
      this.valid = {}
      this.bindCalculator()
    }
  },
  beforeMount () {
    this.bindCalculator()
  },
  methods: {
    bindCalculator () {
      const callback = (v) => {
        let calculator = v
        this.calculator = calculator
        this.calculatorVariants = this._sortObject(calculator.variants)
        this.calculatorVariants.forEach((v, i) => {
          if (!v.email) this.$set(this.calculatorVariants[i], 'email', {})
          if (!v.product) this.$set(this.calculatorVariants[i], 'product', {})
        })

        if (!this.tab) this.tab = `tab_${this.calculatorVariants[0].id}`

        setTimeout(() => { if (this.$refs.form) if (this.$refs.form[0]) this.$refs.form[0].validate() }, 500)
      }
      
      this.$bindRtdb('calculator', this.calculatorDetailsPath, { callback })
      
      // this.$unbindAll()
      // this.$bindxxx(rtdb.ref(this.calculatorDetailsPath), v => {
      //   let calculator = v
      //   this.calculator = calculator
      //   this.calculatorVariants = this._sortObject(calculator.variants)
      //   this.calculatorVariants.forEach((v, i) => {
      //     if (!v.email) this.$set(this.calculatorVariants[i], 'email', {})
      //     if (!v.product) this.$set(this.calculatorVariants[i], 'product', {})
      //   })

      //   if (!this.tab) this.tab = `tab_${this.calculatorVariants[0].id}`

      //   setTimeout(() => { if (this.$refs.form) if (this.$refs.form[0]) this.$refs.form[0].validate() }, 500)
      // })
    },
    addVariant (id) {
      rtdb.ref(`${this.calculatorDetailsPath}/variants/${id}`).set({ id: id, price: 0 })
      this.$set(this.panels, id, 0)
    },
    addAddon (variantId, addonId) {
      rtdb.ref(`${this.calculatorDetailsPath}/variants/${variantId}/addons/${addonId}`).set({ id: addonId })
    },
    deleteAddon (variantId, addonId) {
      rtdb.ref(`${this.calculatorDetailsPath}/variants/${variantId}/addons/${addonId}`).set(null)
    },
    openPanel (panel, id) {
      if (this.panels[id] === 0) {
        this.panels[id] = -1
      } else {
        this.$set(this.panels, id, 0)
      }
    },
    deleteVariant (id) {
      rtdb.ref(`${this.calculatorDetailsPath}/variants/${id}`).set(null)
      rtdb.ref(`${this.calculatorListPath}/variants/${id}`).set(null)
    },
    copyVariant () {
      let { sourceId, targetId } = this.variantsToCopy
      this.confirmCopydialog = false
      this.$vuetify.goTo(0, { duration: 300 })
      this.calculator.variants[targetId] = Object.assign({}, this.calculator.variants[sourceId], { id: targetId, index: this.calculator.variants[targetId].index })
      this.calculatorVariants = this._sortObject(this.calculator.variants)
      this.save()
    },
    copyVariantRequest(sourceId, targetId) {
      this.confirmCopydialog = true
      this.variantsToCopy = { sourceId, targetId }
    },
    reIndex (oldIndex, newIndex) {
      this._arrayMove(this.calculatorVariants, oldIndex, newIndex, true)
      this.showTabs = false
      this.$nextTick(() => { this.showTabs = true }) // do this to rerender the tab slider
      this.save()
    },
    toggleCalculator (state) {
      let updates = {}
      updates[`calculators/_details/${this.calculatorId}/_disabled`] = !state
      updates[`calculators/_list/${this.calculatorId}/_disabled`] = !state
      rtdb.ref().update(updates)
    },
    toggleVariant (id, state) {
      let updates = {}
      updates[`calculators/_details/${this.calculatorId}/variants/${id}/_disabled`] = !state
      updates[`calculators/_list/${this.calculatorId}/variants/${id}/_disabled`] = !state
      rtdb.ref().update(updates)
    },
    async exportCalculator () {
      this.exporting = true
      let data = {}
      let id = this.calculatorId
      let calculatorReq = rtdb.ref(`calculators/${this.calculatorId}`).once('value').then(s => s.val())
      let detailsReq = rtdb.ref(`calculators/_details/${this.calculatorId}`).once('value').then(s => s.val())
      let listReq = rtdb.ref(`calculators/_list/${this.calculatorId}`).once('value').then(s => s.val())

      const [ calculator, details, list ] = await Promise.all([calculatorReq, detailsReq, listReq])

      data[`calculators/_details/${this.calculatorId}`] = details
      data[`calculators/_list/${this.calculatorId}`] = list
      Object.keys(calculator).forEach(k => {
        data[`calculators/${this.calculatorId}/${k}`] = calculator[k]
      })

      this._exportToJsonFile({ id, data }, `Calculator Export - ${this.calculatorId}`)
      this.exporting = false
    },
    handleAssistanceTypesChange (variantId) {
      this.calculator.variants[variantId].assistanceTypes 
        = this.calculator.variants[variantId].assistanceTypes.filter(id => !!this._assistanceTypes[id])
      this.$nextTick(this.save)
    },
    save () {
      let detailsPath = this.calculatorDetailsPath // for the love of god don't remove this. If you click between calculators and a save is triggered it will use the new save path and overwrite the calc unless I keep it locally
      let listPath = this.calculatorListPath // for the love of god don't remove this. If you click between calculators and a save is triggered it will use the new save path and overwrite the calc unless I keep it locally
      let calculator = { ...this.calculator, variants: this._unSortObject(this.calculatorVariants) }
      let { id, name, image, category, _disabled } = calculator
      let listIndex = { id, name, image, category, variants: {}, _disabled,}

      this.calculatorVariants.forEach(v => {
        let { id, name, index, description, moreInfo, canHaveAssistance, product, _disabled } = v
        let price = (v.product || {}).price || 0
        _disabled = Boolean(this.calculator.variants[id]._disabled)
        listIndex.variants[id] = { id, name, index, description, moreInfo, canHaveAssistance, price, product, _disabled }
      })

      let updates = {
        [detailsPath]: this._removeUndefined(calculator),
        [listPath]: this._removeUndefined(listIndex)
      }
      rtdb.ref().update(updates)
    },
    setRestrictedState () {
      rtdb.ref(`${this.calculatorDetailsPath}/unrestricted`).set(!this.calculator.unrestricted)
    }
  }
}
</script>

<style lang="css">
.si-input-centered input{
  text-align: center !important;
}
</style>
